/**
 * 日期格式化工具（Issue #198）。
 *
 * 规则：
 *   - 输入为后端下发的 ISO 8601 字符串。
 *   - 输出为本地化的中文可读格式，不暴露时区信息。
 *   - 禁止在 UI 层直接展示 ISO 字符串。
 */

export function formatDateTime(isoString: string): string {
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return '时间未知';
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const hour = String(d.getHours()).padStart(2, '0');
  const minute = String(d.getMinutes()).padStart(2, '0');
  return `${year}年${month}月${day}日 ${hour}:${minute}`;
}

export function formatDate(isoString: string): string {
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return '日期未知';
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}年${month}月${day}日`;
}

/**
 * 友好相对时间：用于服务进度时间轴、文档上传时间等。
 * 超过 30 天回退到绝对日期，避免"3 个月前"这种容易误读的描述。
 */
export function formatRelativeTime(isoString: string, now: Date = new Date()): string {
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return '时间未知';
  const diffMs = now.getTime() - d.getTime();
  if (diffMs < 0) return formatDateTime(isoString);
  const minutes = Math.floor(diffMs / (60 * 1000));
  if (minutes < 1) return '刚刚';
  if (minutes < 60) return `${minutes} 分钟前`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} 小时前`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days} 天前`;
  return formatDate(isoString);
}
